import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {WorkflowService} from '../../../../services/apiServices/business/workflow-service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng/api';
import {CommonService} from '../../../../services/apiServices/business/common.service';

/**
 * Component represented by signature and validation modal
 */
@Component({
  selector: 'app-signature-and-validation',
  templateUrl: './signature-and-validation.component.html',
  styleUrls: ['./signature-and-validation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignatureAndValidationComponent implements OnInit {

  /**
   * Output Binding for modal opening
   */
  @Output() public displayComponentChange: EventEmitter<boolean>;

  /**
   * Input Binding for modal opening
   */
  @Input('displayComponent') displayComponent: boolean;

  /**
   * List of various users workflows
   */
  @Input('listOfWorkflows') listOfWorkflows: any[];

  /**
   * List of folds per selected workflow
   */
  public listOfFolds: any[];

  /**
   * if the component should render the ground component (reject reason)
   */
  public displayGround: boolean;
  public displayAcceptNotify: boolean;
  public displayRefuseNotify: boolean;

  /**
   * Name of the active workflow
   */
  private activeSpaceName: string;

  /**
   * list of folds ticked by user
   */
  public tickedFolds: any[];

  /**
   * Items for accept select button
   */
  public acceptItems: MenuItem[];
  public refuseItems: MenuItem[];
  /**
   * active selected fold
   */
  public activeFold: any;

  /**
   * Title for success message
   */

  private successTitle: string;
  private warnTitle: string;

  /**
   * Title for error message
   */
  private errorTitle: string;

  /**
   * Error message
   */
  private errorMessage: string;

  /**
   * success message on update
   */
  private successUpdateMessage: string;

  /**
   * success message on accept
   */
  private successAcceptMessage: string;
  private warnAcceptMessage: string;
  private warnRejectMessage: string;

  /**
   * success message on reject
   */
  private successRejectMessage: string;

  /**
   * success message on retry
   */
  private successRetryMessage: string;

  /**
   * constructor that instantiate variables
   *
   * @param {WorkflowService} workflowService - permit httpRequest correctly formatted
   * @param {CommonService} commonService - handle displaying message
   * @param {TranslateService} translate - handle component translation
   */
  constructor(private workflowService: WorkflowService, private commonService: CommonService, private translate: TranslateService) {
    this.tickedFolds = [];
    this.displayComponentChange = new EventEmitter<boolean>();
  }

  /**
   * Affect variables
   */
  public ngOnInit(): void {
    this.displayGround = false;
    this.displayAcceptNotify = false;
    this.displayRefuseNotify = false;
    this.getTradForComponent();
    this.translate.get('SIGNATURE.AND.VALIDATION_COMPONENT.ACCEPT_NOTIFY_BUTTON_LABEL').subscribe((label: string) => {
      this.acceptItems = [
        {label: label,
          icon: 'fa fa-paper-plane',
          command: () => {
            this.displayAcceptNotifyModal();
          }
        }
      ];
    });
    this.translate.get('SIGNATURE.AND.VALIDATION_COMPONENT.DECLINE_NOTIFY_BUTTON_LABEL').subscribe((label: string) => {
      this.refuseItems = [
        {label: label,
          icon: 'fa fa-paper-plane',
          command: () => {
            this.displayRefuseNotifyModal();
          }
        }
      ];
    });
  }

  /**
   * function that handle the change of space (which mean workflow choice) by getting the list of corresponding folds
   * @param {string} name - the new workflow name
   */
  public handleChangeOfSpace(name: string): void {
    this.activeSpaceName = name;
    this.workflowService.getListOfFoldsBySpaceName(name).subscribe(res => {
      this.listOfFolds = res;
    });
  }

  /**
   * set active fold for component binding
   * @param {any} fold - the active fold selected by user
   */
  public setActiveFold(fold: any): void {
    this.activeFold = fold;
  }

  /**
   * set ticked folds for component and also request
   * @param {any[]} folds - the ticked folds selected by user
   */
  public setListOfTicketFolds(folds: any[]): void {
    this.tickedFolds = folds;
  }

  /**
   * update workflow list
   *
   * @param {boolean} displayUpdateNotification - if the request should be processed quietly (without notification)
   */
  public updateWorkflows(displayUpdateNotification: boolean): void {
    this.workflowService.getlistOfWorkflows().subscribe(res => {
      if (res && displayUpdateNotification) {
        this.commonService.addToast({life: 3000, severity: 'info', summary: this.successTitle, detail: this.successUpdateMessage});
      } else if (displayUpdateNotification && !res) {
        this.displayError();
      }
      this.listOfWorkflows = res;
      this.resetComponent();
    });
  }

  /**
   * reset component to original state
   */
  private resetComponent(): void {
    this.tickedFolds = [];
    this.listOfFolds = [];
    this.activeFold = null;
  }
  private displayAcceptNotifyModal(): void {
    this.displayAcceptNotify = true;
  }
  private displayRefuseNotifyModal(): void {
    this.displayRefuseNotify = true;
  }
  /**
   * If the users wants to accept ticked folds
   */
  public acceptFolds(): void {

    this.workflowService.acceptListOfFolds(this.tickedFolds, this.activeSpaceName, []).subscribe(res => {
      if (res.body && res.body.bOK) {
        this.commonService.addToast({
          life: 2000,
          severity: 'success',
          summary: this.successTitle,
          detail: this.successAcceptMessage
        });
      } else {
        this.displayError();
      }
      this.updateWorkflows(false);
    });
  }
  /**
   * If the users wants to accept ticked folds and send email notification
   */
  public acceptFoldsAndNotify(emailList: string[]): void {
    this.workflowService.acceptListOfFolds(this.tickedFolds, this.activeSpaceName, emailList).subscribe(res => {
      if (res.body && res.body.bOK) {
        if (res.body.datas && !res.body.datas.mailSent) {
          this.commonService.addToast({
            life: 5000,
            severity: 'warn',
            summary: this.warnTitle,
            detail: this.warnAcceptMessage
          });
        } else {
          this.commonService.addToast({life: 2000,
            severity: 'success',
            summary: this.successTitle,
            detail: this.successAcceptMessage
          });
        }
      } else {
        this.displayError();
      }
      this.updateWorkflows(false);
    });
  }
  /**
   * If the users wants to accept ticked folds and send email notification
   */
  public rejectFoldsAndNotify(rejectInfo: any): void {
    this.workflowService.rejectListOfFolds(this.tickedFolds, this.activeSpaceName, rejectInfo.emailList, rejectInfo.rejectReason).subscribe(res => {
      if (res.body && res.body.bOK) {
        this.commonService.addToast({life: 3000, severity: 'success', summary: this.successTitle, detail: this.successRejectMessage});
        if (res.body.datas && !res.body.datas.mailSent) {
          this.commonService.addToast({
            life: 5000,
            severity: 'warn',
            summary: this.warnTitle,
            detail: this.warnRejectMessage
          });
        } else {
          this.commonService.addToast({life: 2000,
            severity: 'success',
            summary: this.successTitle,
            detail: this.successRejectMessage
          });
        }
      } else {
        this.displayError();
      }
      this.updateWorkflows(false);
    });
  }

  /**
   * If the users wants to reject ticked folds
   *
   * @param {string} refusalReason - reason why the user wants to reject the fold (it can be empty)
   */
  private rejectFolds(refusalReason: string): void {
    this.workflowService.rejectListOfFolds(this.tickedFolds, this.activeSpaceName, [], refusalReason).subscribe(res => {
      if (res) {
        this.commonService.addToast({life: 3000, severity: 'success', summary: this.successTitle, detail: this.successRejectMessage});
      } else {
        this.displayError();
      }
      this.updateWorkflows(false);
    });
  }

  /**
   * If the users wants to retry ticked folds
   */
  public retryFolds(): void {
    this.workflowService.retryListOfFolds(this.tickedFolds, this.activeSpaceName).subscribe(res => {
      if (res) {
        this.commonService.addToast({life: 3000, severity: 'success', summary: this.successTitle, detail: this.successRetryMessage});
      } else {
        this.displayError();
      }
      this.updateWorkflows(false);
    });
  }

  /**
   * handle confirmation for refusal if the users wants to reject ticked folds
   *
   * @param {string} refusalReason - reason why the user wants to reject the fold (it can be empty)
   */
  public accept(refusalReason: string) {
    this.rejectFolds(refusalReason);
  }
  public handleRefusal(refusalReason: string) {
    this.rejectFolds(refusalReason);
  }

  /**
   * stop rendering component and reset to original state
   */
  public closeModal(): void {
    this.resetComponent();
    this.displayComponentChange.emit(false);
  }

  /**
   * display error message on request fail
   */
  private displayError(): void {
    this.commonService.addToast({life: 3000, severity: 'error', summary: this.errorTitle, detail: this.errorMessage});
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((res: string) => {
      this.successTitle = res;
    });
    this.translate.get('TOASTER.WARNING_MESSAGE_TITLE').subscribe((res: string) => {
      this.warnTitle = res;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((res: string) => {
      this.errorTitle = res;
    });
    this.translate.get('TOASTER.SUCCESS_UPDATE_MESSAGE').subscribe((res: string) => {
      this.successUpdateMessage = res;
    });
    this.translate.get('TOASTER.SUCCESS_ACCEPT_MESSAGE').subscribe((res: string) => {
      this.successAcceptMessage = res;
    });
    this.translate.get('TOASTER.WARN_ACCEPT_MESSAGE').subscribe((res: string) => {
      this.warnAcceptMessage = res;
    });
    this.translate.get('TOASTER.WARN_REJECT_MESSAGE').subscribe((res: string) => {
      this.warnRejectMessage = res;
    });
    this.translate.get('TOASTER.SUCCESS_REJECT_MESSAGE').subscribe((res: string) => {
      this.successRejectMessage = res;
    });
    this.translate.get('TOASTER.SUCCESS_RETRY_MESSAGE').subscribe((res: string) => {
      this.successRetryMessage = res;
    });
    this.translate.get('TOASTER.FAIL_REQUEST').subscribe((res: string) => {
      this.errorMessage = res;
    });

  }
}
